import React from 'react';
import { useSelector } from 'react-redux';
import { SelectShowCloudAgents } from 'store/Agents/selectors';
import { Wrapper, Text, Link } from './styled';

const EmptyAgents = () => {
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const entityName = showCloudAgents ? 'Security Scanners' : 'Runners';

  return (
    <Wrapper>
      <Text>
        {`You don't have any ${entityName} yet, create one to get started or `}
        <Link href="https://docs.agents.faradaysec.com/getting-started/" target="_blank"> check our documentation</Link>
        .
      </Text>
    </Wrapper>
  );
};

export default EmptyAgents;
